<div class="modal-header border-b">
    <h4 class="modal-title title">{{modelHeader}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body margin-td">
    <p class="modal-desc py-4">{{modelBody}}</p>
  </div>
  <div class="modal-footer">
  <button type="button" class="btn btn-primary mr-sm-2" aria-label="Center Align" (click)="activeModal.dismiss(true)" translate>lblYes</button>
  <button type="button" class="btn btn-secondary " aria-label="Center Align" (click)="activeModal.dismiss(false)" translate>lblNo</button>
  </div>
